module.exports = __webpack_public_path__ + "img/ledger-city-intro.53d3d697.png";